/* eslint-disable react-hooks/exhaustive-deps */
import { AlertTost, CustomModal, CustomTable, RowAction } from "#components";
import ImagesUrl from "#constants/images.js";
import useGet from "#hooks/useGet.js";
import { TableLayout } from "#layouts";
import { WebRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { convertDate, FiledProcessData, UseDebounce } from "#utils/helpers.js";
import { felidTableHeader } from "#utils/seeds.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactSelector from "../../components/ReactSelector";
import { useFormik } from "formik";
import { CropValidationSchema } from "#validations/validationSchema.js";
import { cropInitialValues } from "#validations/initialValues.js";
import globalConfig from "#constants/globalConfig.js";
import toast from "react-hot-toast";
import usePost from "#hooks/usePost.js";

const FieldListing = ({
  currentPage,
  onDataCountChange,
  handlePrevPage,
  handleNextPage,
  dataCount,
  onOpen,
  toggleRow,
  expandedRow,
  growerId,
  handleDeleteField,
  setCurrentPage,
  open,
  showView,
}) => {
  const [formattedData, setFormattedData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [cropModalOpen, setCropModalOpen] = useState({
    add: false,
    edit: false,
  });
  const GrowerId = JSON.parse(localStorage.getItem(globalConfig.GROWER_ID));
  const [cropDetail, setCropDetail] = useState(null);
  const [seasonId, setSeasonId] = useState(null);

  const { data: cropListData, isLoading: isCropLoading } = useGet(
    ENDPOINTS.CROP_LIST,
    QUERY_KEYS.CROP_LIST_QUERY_KEY
  );
  const nav = useNavigate();
  const {
    data: fieldListData,
    isLoading: isFieldLoading,
    refetch: refetchFieldList,
  } = useGet(
    ENDPOINTS.LIST_FIELD,
    [QUERY_KEYS.LIST_FIELD_QUERY_KEY, UseDebounce(searchInput)],
    {
      growerId: growerId?.id,
      page: currentPage,
      limit: dataCount,
      search: searchInput,
    }
  );
  const { mutateAsync: addCropMutateAsync, isLoading: isLoadingAddCrop } =
    usePost(ENDPOINTS.ADD_CROP, QUERY_KEYS.ADD_CROP_LIST_QUERY_KEY);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: cropInitialValues,
    validationSchema: CropValidationSchema,

    onSubmit: async (value) => {
      const addData = {
        fieldId: cropDetail?._id,
        cropId: values?.cropId,
        cropName: values?.cropName,
        growerId: GrowerId,
        seasonId: seasonId,
      };

      try {
        const response = await addCropMutateAsync(addData);
        AlertTost(response?.message, "success");
        resetForm();
        onCloseCropModal("add");
        refetchFieldList();
      } catch (error) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    },
  });

  const onSearchChange = (e) => {
    setSearchInput(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    refetchFieldList();
  }, [growerId, handleDeleteField, formattedData, open]);
  useEffect(() => {
    if (searchInput === "") {
      refetchFieldList();
    }
  }, [searchInput]);
  useEffect(() => {
    if (fieldListData && fieldListData.data && fieldListData.data.list) {
      const formatted = FiledProcessData(fieldListData.data.list);
      setFormattedData(formatted);
    }
  }, [fieldListData]);
  // crop modal function
  const onCloseCropModal = (key) => {
    setCropModalOpen({
      ...open,
      [key]: false,
    });
    setCropDetail(null);
    resetForm();
  };
  const onOpenCropModal = (key, data, id) => {
    setCropModalOpen({ ...open, [key]: true });
    setSeasonId(id);
    setCropDetail(data);
  };

  // Crop Options
  const cropOptions = cropListData?.data?.map((item) => ({
    id: item?._id,
    value: item?._id,
    label: item?.name,
  }));
  const uniqueYears = Array.from(
    new Set(
      formattedData?.flatMap((field) =>
        field.seasons?.map((season) => season.year)
      )
    )
  ).sort((a, b) => Number(b) - Number(a)); // optional descending order

  return (
    <div className="tab-pane fade show active mt-4">
      <div className="tab-content-wrapper">
        <div className="row">
          <div className="col-xl-12">
            <div className="sub-heading flex-box">
              <h2>Listing </h2>
              <div className="side-content-blk">
                <div className="side-content-blk">
                  <div className="form-block p-relative">
                    <input
                      type="text"
                      className="form-control"
                      id="search"
                      placeholder="Search field name, crop name"
                      value={searchInput}
                      onChange={onSearchChange}
                      onKeyPress={(e) =>
                        e.key === "Enter" && refetchFieldList()
                      }
                    />
                    <span className="search-icon" />
                  </div>
                </div>
                <button className="primary-btn" onClick={() => onOpen("add")}>
                  Add New Field
                </button>
              </div>
            </div>

            <TableLayout
              tableHeader={felidTableHeader(formattedData)}
              isEmpty={formattedData?.length === 0}
              isLoading={isFieldLoading}
              currentPage={currentPage}
              totalItems={fieldListData?.data?.totalItems}
              onDataCountChange={onDataCountChange}
              handlePrevPage={handlePrevPage}
              handleNextPage={handleNextPage}
              rowLimit={dataCount}
            >
              <CustomTable tableHeader={felidTableHeader(formattedData)}>
                {formattedData?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr
                        className="cursor-pointer position-relative"
                        key={index}
                      >
                        <td onClick={() => toggleRow(index)}>
                          <span className="hstack gap-3">
                            {item?.subFields?.length > 0 ? (
                              <span
                                className={`drop_icon ${
                                  expandedRow === index ? "active" : ""
                                }`}
                              >
                                <img
                                  onClick={() => toggleRow(index)}
                                  className="drop_icon"
                                  src={ImagesUrl.dopeIcon}
                                  alt="drop-icon .."
                                />
                              </span>
                            ) : (
                              <span
                                className={`drop_icon ${
                                  expandedRow === index ? "active" : ""
                                }`}
                              ></span>
                            )}

                            <span>{item?.name}</span>
                          </span>
                        </td>
                        <td onClick={() => toggleRow(index)}>{item?.area}</td>

                        {/* {uniqueYears.map((year) => {
                          const cropEntry = item?.cropData?.find(
                            (crop) => crop.year === year
                          );

                          return (
                            <td key={year}>
                              {cropEntry?.cropName ? (
                                cropEntry.cropName
                              ) : (
                                <span
                                  onClick={() => {
                                    const seasonEntry = item?.seasons?.find(
                                      (season) => season.year === year
                                    );
                                    const seasonIdToUse =
                                      cropEntry?.seasonId ||
                                      seasonEntry?.seasonId;

                                    onOpenCropModal("add", item, seasonIdToUse);
                                  }}
                                  style={{
                                    color: "#929292",
                                    cursor: "pointer",
                                  }}
                                >
                                  Select Crop +
                                </span>
                              )}
                            </td>
                          );
                        })} */}
                        {uniqueYears.map((year) => {
                          const seasonEntry = item?.seasons?.find(
                            (season) => season.year === year
                          );
                          const cropEntry = item?.cropData?.find(
                            (crop) => crop.seasonId === seasonEntry?.seasonId
                          );

                          return (
                            <td key={year}>
                              {cropEntry?.cropName ? (
                                cropEntry.cropName
                              ) : (
                                <span
                                  onClick={() => {
                                    const seasonIdToUse = seasonEntry?.seasonId;
                                    onOpenCropModal("add", item, seasonIdToUse);
                                  }}
                                  style={{
                                    color: "#929292",
                                    cursor: "pointer",
                                  }}
                                  className=" cursor-pointer text-sm sm:text-sm"
                                >
                                  Select Crop +
                                </span>
                              )}
                            </td>
                          );
                        })}

                        <RowAction
                          activeAction={{
                            edit: true,
                            view: !showView,

                            delete: true,
                            status: false,
                          }}
                          onEdit={() => onOpen("edit", item)}
                          onDelete={() => handleDeleteField(item._id)}
                          onView={() => {
                            nav(WebRoutePath.FIELD_MANAGEMENT_DETAIL.path, {
                              state: { GrowerId: growerId, fieldDetail: item },
                            });
                          }}
                        />
                      </tr>

                      {expandedRow === index &&
                        item?.subFields?.map((subRowData, i) => {
                          return (
                            <tr
                              className={`sub-row ${
                                expandedRow === index ? "expanded" : ""
                              }`}
                              key={i}
                            >
                              <td>{subRowData?.name}</td>
                              <td>{subRowData?.cropName}</td>
                              <td>{"-"}</td>
                              <td>{convertDate(subRowData?.updatedAt)}</td>
                              <td>-</td>
                            </tr>
                          );
                        })}
                    </React.Fragment>
                  );
                })}
              </CustomTable>
            </TableLayout>
          </div>
        </div>
      </div>
      <CustomModal
        open={cropModalOpen.add || cropModalOpen.edit}
        title={cropModalOpen.add ? "Add Crop" : "Edit Cop"}
        actionButtonTitle={cropModalOpen.add ? "Save" : "Update"}
        onClose={() => onCloseCropModal(cropModalOpen.add ? "add" : "edit")}
        onSubmit={() => {
          handleSubmit();
        }}
        loading={isLoadingAddCrop}
        // bodyClass="modal-body p-0 border_structure"
      >
        <div className="common-modal-form">
          <ReactSelector
            label="Crop"
            customClass={"col-lg-12"}
            options={cropOptions}
            placeholder="Select"
            value={{
              id: values?.cropId,
              value: values?.cropId,
              label: values?.cropName,
            }}
            isLoading={isCropLoading}
            onChange={(value) => {
              setValues({
                ...values, // Keep the other values intact
                cropId: value?.id || "",
                cropName: value?.label || "",
              });
            }}
            error={errors?.cropId}
            onBlur={handleBlur}
            touched={touched?.cropId}
          />
        </div>
      </CustomModal>
    </div>
  );
};

export default FieldListing;
